import React, { useState, useEffect } from "react";
import { BASE_URL } from "../env";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import ToolkitProvider, {
	CSVExport,
	Search,
} from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";

const { SearchBar } = Search;
const { ExportCSVButton } = CSVExport;

const QuizExamEdit = () => {
	const [courseData, setCourseData] = useState([]);
	const [tabledata, settabledata] = useState([]);

	useEffect(() => {
		fetch(BASE_URL + "/getQuizAllEXam")
			.then((res) => res.json())
			.then((data) => {
				console.log(data);
				setCourseData(data?.data);
			});
	}, []);

	let newdata = [];
	useEffect(() => {
		for (var i = 0; i < courseData.length; i++) {
			newdata.push({
				sno: i + 1,
				category: courseData[i],
				coursename: courseData[i]?.courseId?.name,
				company: courseData[i],
				description: courseData[i]?.description,
				examname: courseData[i],
				examattempted: courseData[i]?.examAttempted,
				time: courseData[i]?.timer,
				questions: courseData[i]?.questions.length,
			});
		}
		settabledata(newdata);
		// console.log(JSON.stringify(newdata));
	}, [courseData]);

	let priceFilter;

	const columns = [
		{
			dataField: "sno",
			text: "S no.",
			sort: true,
			headerStyle: () => {
				return {
					width: "5%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
				style: {
					height: "5px",
				},
			}),
		},
		{
			dataField: "category",
			text: "Category",
			sort: true,
			formatter: (cell) => (
				<a href={`/quiz-edit/${cell._id}`}> {cell.category} </a>
			),

			filter: textFilter({
				style: {
					height: "5px",
				},
			}),
			headerStyle: () => {
				return {
					width: "10%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
		},
		{
			dataField: "coursename",
			text: "Course Name",
			sort: true,

			filter: textFilter({
				style: {
					height: "5px",
				},
			}),
			headerStyle: () => {
				return {
					width: "10%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
		},
		{
			dataField: "company",
			text: "Company",
			sort: true,
			formatter: (cell) => (
				<a href={`/quiz-edit/${cell._id}`}> {cell.company} </a>
			),

			filter: textFilter({
				style: {
					height: "5px",
				},
			}),
			headerStyle: () => {
				return {
					width: "10%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
		},
		{
			dataField: "description",
			text: "Description",
			sort: true,
			// formatter: (cell) => {cell.setAttribute('maxlength',5)},
			filter: textFilter({
				style: {
					height: "5px",
				},
			}),
			headerStyle: () => {
				return {
					width: "10%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
		},
		{
			dataField: "examname",
			text: "Exam Name",
			sort: true,
			formatter: (cell) => (
				<a href={`/quiz-edit/${cell._id}`}> {cell.examName} </a>
			),
			filter: textFilter({
				style: {
					height: "5px",
				},
			}),
			headerStyle: () => {
				return {
					width: "10%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
		},
		{
			dataField: "examattempted",
			text: "Exam Attempted",
			sort: true,
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
				style: {
					height: "5px",
				},
			}),
			headerStyle: () => {
				return {
					width: "10%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
		},
		{
			dataField: "questions",
			text: "Total Questions",
			sort: true,
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
				style: {
					height: "5px",
				},
			}),
			headerStyle: () => {
				return {
					width: "10%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
		},
		{
			dataField: "time",
			text: "Total Time",
			sort: true,
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
				style: {
					height: "5px",
				},
			}),
			headerStyle: () => {
				return {
					width: "10%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
		},
	];
	const [rowcount, setRowcount] = useState(tabledata.length);
	const handleDataChange = ({ dataSize }) => {
		setRowcount(dataSize);
	};
	const numberStyle = {
		border: "2px solid black",
		boxShadow: "4px 4px rgba(93, 93, 93)",
		borderRadius: "20px",
		fontFamily: "Poppins-Bold",
		color: "white",
	};

	return (
		<div style={{ margin: "20px" }}>
			<h1 style={{ textAlign: "center", fontWeight: "900" }}>
				Quiz Exam Edit
			</h1>
			<div className="mx-2 w-25 p-3 bg-dark " style={numberStyle}>
				Row Count:<span style={{ color: "yellow" }}>{rowcount}</span>
			</div>
			<ToolkitProvider
				keyField={"sno"}
				data={tabledata}
				columns={columns}
				exportCSV={{
					fileName: "quizexam_results.csv",
					blobType: "text/csv;charset=ansi",
					onlyExportFiltered: true,
					exportAll: false,
				}}
				search
			>
				{(props) => (
					<div>
						<div className="d-flex justify-content-between">
							<ExportCSVButton
								{...props.csvProps}
								className="btn btn-md bg-warning my-2 "
								style={{
									borderRadius: "10px",
									marginLeft: "20px",
								}}
							>
								Download All Data
							</ExportCSVButton>
							<SearchBar
								{...props.searchProps}
								style={{
									width: "300px",
									height: "5px",
									marginRight: "20px",
								}}
							/>
						</div>
						<br />
						<BootstrapTable
							{...props.baseProps}
							filter={filterFactory()}
							// condensed
							onDataSizeChange={handleDataChange}
							bootstrap4
							loading
							pagination={paginationFactory()}
							// classes="text-white"
							striped
						/>
					</div>
				)}
			</ToolkitProvider>
		</div>
	);
};

export default QuizExamEdit;
